<template>
  <div class="catalog-form">
    <h1>
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action" v-if="id" @click="init"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action" v-if="editButton" @click="onEdit"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action" v-if="showOpenCloseButton" @click="handleOpenCloseDomain"><i class="fal" :class="[form.closed ? 'fa-lock-open-alt' : 'fa-lock-alt']"></i> {{ form.closed ? 'Abrir' : 'Cerrar' }}</div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#init" class="list-group-item list-group-item-action" aria-current="true" v-if="id">
          Actualizaciones
        </a>
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#admin" class="list-group-item list-group-item-action" aria-current="true" v-if="editAdminDataPermission">
          Datos administrativos
        </a>
        <a href="#workspace" class="list-group-item list-group-item-action" aria-current="true" v-if="idClient">
          Datos Cliente - Dominio
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!loading">
        <b-card id="init" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Usuario</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ form.creationUser && form.creationUser.name || '--' }}</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ form.updateUser && form.updateUser.name || '--' }}</td>
                <td>{{ updateDate }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- INFORMACION GENERAL -->
        <b-card id="general" class="form-section">
          <template #header>
            Información general
            <small class="text-muted d-block">
              Estado:
              <span
                class="badge badge-pill badge-secondary"
                :class="[ form.closed ? 'badge-danger' : 'badge-info']"
              >{{ form.getDomainStatusLabel() }}</span>
            </small>
          </template>
          <b-form-group
            id="input-group-name"
            label="Nombre *"
            label-for="input-domain-name">
            <b-form-input
              id="input-domain-name"
              name="input-domain-name"
              type="text"
              class="shadow-none"
              placeholder="Nombre del dominio"
              v-model.trim="form.name"
              :maxlength="255"
              v-validate="{ required: true, regex: regexDomainName }"
              :state="validateState('input-domain-name')"
              aria-describedby="input-name-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-name-feedback">El nombre es requerido, este debe contener únicamente valores alfanuméricos y guiones (_,-)</b-form-invalid-feedback>
            <small v-if="form.id" class="text-muted">ID del dominio: {{form.id}}</small>
          </b-form-group>

          <div v-if="editOperationsDataPermission">
            <b-form-group
              id="input-group-security-level"
              label="Nivel de seguridad *"
              label-for="input-select-security-level">
              <b-form-select
                id="input-select-security-level"
                name="input-select-security-level"
                class="shadow-none mb-1"
                placeholder="Nivel de seguridad"
                v-validate="{ required: true }"
                :state="validateState('input-select-security-level')"
                aria-describedby="input-select-security-level-feedback"
                v-model="form.securityLevel"
                :options="securityLevelOptions"
                :disabled="readOnly">
              </b-form-select>
              <b-form-invalid-feedback id="input-select-security-level-feedback">El nivel de seguridad es requerido</b-form-invalid-feedback>
              <password-details
                description="La contraseña de los usuarios debe cumplir lo siguiente:"
                :domain-security-level="form.securityLevel"/>
            </b-form-group>

            <b-form-group
              id="input-group-version-webbmf"
              label="Versión de webbmf mínima requerida para operar en el dominio"
              label-for="input-version-webbmf">
              <b-form-input
                id="input-version-webbmf"
                name="input-version-webbmf"
                type="number"
                class="shadow-none"
                min="0"
                placeholder="Ingrese el número de versión"
                v-model.trim="form.webBMFMinimumRevision"
                :disabled="readOnly">
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-broadcast"
              label="Broadcast"
              label-for="input-broadcast">
              <b-form-input
                id="input-broadcast"
                name="input-broadcast"
                type="text"
                class="shadow-none"
                placeholder="Broadcast"
                v-model.trim="form.broadcast"
                :maxlength="255"
                :disabled="readOnly">
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-use-predictive"
              label="Utilizar predictive dialer options"
              label-for="input-use-predictive">
              <b-form-select
                id="input-use-predictive"
                name="input-use-predictive"
                class="shadow-none"
                v-model="form.usePredictiveDialerOpt"
                :options="yesNoOptions"
                :disabled="readOnly">
              </b-form-select>
            </b-form-group>

            <b-form-group
              id="input-group-limit-licenses"
              label="Límite de licencias"
              label-for="input-limit-licenses">
              <b-form-select
                id="input-limit-licenses"
                name="input-limit-licenses"
                class="shadow-none"
                v-model="form.limitLicenses"
                :options="yesNoOptions"
                :disabled="readOnly">
              </b-form-select>
            </b-form-group>

            <b-form-group
              id="input-group-maps-providers"
              label="Proveedor de mapas"
              label-for="input-maps-providers">
              <b-form-select
                id="input-maps-providers"
                name="input-maps-providers"
                class="shadow-none"
                v-model="form.mapProvider"
                :options="mapProviderOptions"
                :disabled="readOnly">
              </b-form-select>
            </b-form-group>

            <b-form-group
              id="input-group-full-search-type"
              label="Proveedor de búsqueda avanzada"
              label-for="input-full-search-type">
              <b-form-select
                id="input-full-search-type"
                name="input-full-search-type"
                class="shadow-none"
                v-model="form.fullTextSearchType"
                :options="fullTextSearchTypeOptions"
                :disabled="readOnly">
              </b-form-select>
            </b-form-group>

            <b-form-group
              id="input-group-tracker-mode"
              label="Tracking mode"
              label-for="input-tracker-mode">
              <b-form-select
                id="input-tracker-mode"
                name="input-tracker-mode"
                class="shadow-none"
                v-model="form.trackingMode"
                :options="trackerModeOptions"
                :disabled="readOnly">
              </b-form-select>
            </b-form-group>

            <b-form-group
              id="input-group-rate-limit"
              label="Rate limit time"
              label-for="input-rate-limit">
              <b-form-input
                id="input-rate-limit"
                name="input-rate-limit"
                type="number"
                class="shadow-none"
                v-model.trim="form.rateLimitTime"
                :disabled="readOnly">
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-rate-ws"
              label="Rate limit WS"
              label-for="input-rate-ws">
              <b-form-input
                id="input-rate-ws"
                name="input-rate-ws"
                type="number"
                class="shadow-none"
                v-model.trim="form.rateLimitWS"
                :disabled="readOnly">
              </b-form-input>
            </b-form-group>
          </div>
        </b-card>

        <!-- DATOS ADMINISTRATIVOS -->
        <b-card id="admin" header="Datos administrativos" class="form-section" v-if="editAdminDataPermission">
          <b-form-group
            id="input-group-name"
            label="Segmento de negocio *"
            label-for="input-business-segment">
            <b-form-input
              id="input-business-segment"
              name="input-business-segment"
              type="text"
              class="shadow-none"
              placeholder="3 dígitos (Ej: 001, 111, 100, etc)"
              v-model.trim="form.businessSegment"
              :maxlength="3"
              v-validate="{ required: true, regex: regexBusinessSegment }"
              :state="validateState('input-business-segment')"
              aria-describedby="input-business-segment-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-business-segment-feedback">El valor debe contener 3 digitos, permitiendo ceros a la izquierda</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-security-level"
            label="Línea de producto *"
            label-for="input-product-line">
            <b-form-select
              id="input-product-line"
              name="input-product-line"
              class="shadow-none"
              v-model="form.productLine"
              :options="productLineOptions"
              v-validate="{ required: true }"
              :state="validateState('input-product-line')"
              aria-describedby="input-product-line-feedback"
              :disabled="readOnly">
            </b-form-select>
            <b-form-invalid-feedback id="input-product-line-feedback">La línea de producto es requerida</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-security-level"
            label="Categoría de cliente *"
            label-for="input-domain-type">
            <b-form-select
              id="input-domain-type"
              name="input-domain-type"
              class="shadow-none"
              v-model="form.domainType"
              :options="domainTypesOptions"
              v-validate="{ required: true }"
              :state="validateState('input-domain-type')"
              aria-describedby="input-domain-type-feedback"
              :disabled="readOnly || !couldBeIndividual">
            </b-form-select>
            <b-form-invalid-feedback id="input-domain-type-feedback">La categoría de cliente es requerida</b-form-invalid-feedback>
            <small class="text-muted" v-if="!couldBeIndividual">Este Dominio ya no puede ser Individual ya que cuenta con más de dos workspaces.</small>
          </b-form-group>

          <b-form-group
            id="input-group-name"
            label="Código de facturación *"
            label-for="input-billing-code">
            <b-form-input
              id="input-billing-code"
              name="input-billing-code"
              type="text"
              class="shadow-none"
              placeholder="10 dígitos"
              v-model.trim="form.billingCode"
              :maxlength="10"
              v-validate="{ required: true, regex: regexBillingCode }"
              :state="validateState('input-billing-code')"
              aria-describedby="input-billing-code-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-billing-code-feedback">El valor debe contener de 10 digitos</b-form-invalid-feedback>
          </b-form-group>
        </b-card>

        <!-- DATOS DE LA ASOCIACION CON CLIENTE -->
        <b-card id="workspace" header="Datos de la relación Cliente - Dominio" class="form-section" v-if="idClient">
          <div class="row">
            <div class="col-sm-12">
              <b-form-group id="input-group-facturation-date" label="Día de facturación">
                <b-form-select
                  id="input-select-facturation-date"
                  name="input-select-facturation-date"
                  class="shadow-none"
                  v-model="formWorkspace.facturationDate"
                  :options="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]">
                </b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <b-form-group
                id="input-group-contact-name"
                label="Contacto *"
                label-for="input-contact-name">
                <b-form-input
                  id="input-contact-name"
                  name="input-contact-name"
                  type="text"
                  class="shadow-none"
                  placeholder="Nombre del contacto"
                  v-model.trim="formWorkspace.contact.name"
                  :maxlength="255"
                  v-validate="{ required: true }"
                  :state="validateState('input-contact-name')"
                  aria-describedby="input-contact-name-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-contact-name-feedback">El nombre del contacto es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-email"
                label="Correo electrónico *"
                label-for="input-email">
                <b-form-input
                  id="input-email"
                  name="input-email"
                  type="email"
                  class="shadow-none"
                  placeholder="Correo electrónico"
                  v-model.trim="formWorkspace.contact.contactEmail"
                  :maxlength="255"
                  v-validate="{ required: true, email: true  }"
                  :state="validateState('input-email')"
                  aria-describedby="input-email-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-email-feedback">Introduzca un correo válido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-phone"
                label="Teléfono *"
                label-for="input-phone">
                <b-form-input
                  id="input-phone"
                  name="input-phone"
                  type="text"
                  class="shadow-none"
                  placeholder="Ej. 5537081925, +525537081925"
                  v-model.trim="formWorkspace.contact.contactTelephone"
                  :maxlength="16"
                  v-validate="{ required: true, regex: regexPhone  }"
                  :state="validateState('input-phone')"
                  aria-describedby="input-phone-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-phone-feedback">Introduzca un teléfono válido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <b-form-group>
            <b-form-checkbox v-model="formWorkspace.consolidatedInvoice">Detalle consolidado en factura</b-form-checkbox>
          </b-form-group>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right">
          <b-button class="mr-2" size="lg" @click="onCancel">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly">Guardar dominio</b-button>
        </div>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Domain, Workspace, DomainSecurityLevel, MapProvider, FullTextSearchType, TrackingMode, DomainType } from '@/types/Catalogs'
import DateSelector from '@/components/generic/DateSelector.vue'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import messageService from '@/services/support/MessageService'
import { RoleNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import DateFormat from '@/services/DateFormat'
import PasswordDetails from '../generic/PasswordDetails.vue'

@Component({
  components: {
    DateSelector,
    LoadingMask,
    MessageError,
    PasswordDetails
  }
})
export default class AdminDomainForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: false, default: 0 })
  idClient: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: false })
  editButton: boolean

  @Prop({ required: false, default: () => [] })
  workspaces: []

  @Prop({ required: false, default: false })
  showOpenCloseButton: boolean

  MAX_WORKSPACES_FOR_INDIVIDUAL_DOMAIN = 2
  loading = false
  domainLevels = DomainSecurityLevel

  form = Domain.getIntanceForEdit()
  formWorkspace = Workspace.getIntanceForEdit()

  securityLevelOptions = [
    { value: '', text: '-- Seleccione --' },
    { value: DomainSecurityLevel.LOW, text: 'Bajo' },
    { value: DomainSecurityLevel.MEDIUM, text: 'Medio' },
    { value: DomainSecurityLevel.HIGH, text: 'Alto' }
  ]
  yesNoOptions = [ { value: false, text: 'No' }, { value: true, text: 'Sí' } ]
  mapProviderOptions = [
    { value: '', text: '-- Seleccione --' },
    { value: MapProvider.MAPBOX, text: 'MAPBOX' },
    { value: MapProvider.GOOGLE, text: 'GOOGLE' }
  ]
  fullTextSearchTypeOptions = [
    { value: '', text: '-- Seleccione --' },
    { value: FullTextSearchType.ELASTIC, text: 'Elastic Search' }
  ]
  trackerModeOptions = [
    { value: '', text: 'Desactivado' },
    { value: TrackingMode.PASIVO, text: 'Pasivo' },
    { value: TrackingMode.INTENSIVO, text: 'Intensivo' }
  ]
  productLineOptions = [ { value: 'Smartforms', text: 'Smartforms' } ]
  domainTypesOptions = [
    { value: '', text: '-- Seleccione --' },
    { value: DomainType.ECOSYSTEM, text: 'Ecosistema' },
    { value: DomainType.INDIVIDUAL, text: 'Cliente individual' }
  ]
  regexPhone = /^[+]?[0-9]{10,15}$/
  regexBusinessSegment = /^[0-9]{3}$/
  regexBillingCode = /^[a-zA-Z0-9]{10}$/
  regexDomainName = /^[0-9a-zA-Z_-]{3,50}$/

  creationDate = ''
  updateDate = ''

  domainBackup = ''

  mounted () {
    this.init()
  }

  init () {
    if (this.id) {
      this.loading = true
      catalogsService.getDomainById(this.id).then(data => {
        this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
        data.trackingMode = data.trackingMode || ''
        data.mapProvider = data.mapProvider || ''
        data.broadcast = data.broadcast || ''

        Object.assign(this.form, data)

        this.domainBackup = JSON.stringify(this.form)
        this.$validator.reset()
      }).finally(() => {
        this.loading = false
      })
    }
  }

  get editOperationsDataPermission () {
    return userInfoStore.userInfo.role.name === RoleNames.OPERATIONS_ADMIN
  }

  get editAdminDataPermission () {
    return userInfoStore.userInfo.role.name === RoleNames.FINANCES_ADMIN || userInfoStore.userInfo.role.name === RoleNames.FINANCES_CONTROL
  }

  /**
   * Check if the current ecosystem domain can change to individual
   */
  get couldBeIndividual (): boolean {
    return this.workspaces.length <= this.MAX_WORKSPACES_FOR_INDIVIDUAL_DOMAIN
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  onSubmit () {
    this.$validator.validateAll().then(result => {
      if (result) {
        if (JSON.stringify(this.form) === this.domainBackup) {
          // If there are no changes then return to main grid
          this.onCancel()
          return
        }

        this.loading = true
        this.form.updateDate = new Date()
        if (!this.form.id) this.form.creationDate = new Date()
        catalogsService.saveDomain(this.form).then((response: Domain) => {
          this.form.id = response.id

          if (this.idClient) {
            this.formWorkspace.client.id = this.idClient
            this.formWorkspace.domain.id = this.form.id
            this.formWorkspace.owner = true
            catalogsService.saveWorkspace(this.formWorkspace).then((response: Workspace) => {
              this.$emit('saved', this.form)
            }).catch((error) => {
              messageService.error('Error al guardar la relación Cliente - Dominio', `${error.response!.data!.description} - ${error.response!.data!.message}`)
            }).finally(() => {
              this.loading = false
            })
          } else {
            this.$emit('saved', this.form)
          }
        }).catch((error) => {
          messageService.error('Error al guardar el dominio.', `${error.response!.data!.description} - ${error.response!.data!.message}`)
        }).finally(() => {
          this.loading = false
        })
      } else {
        messageService.error('Errores en el formulario', 'Revise los campos marcados con error', 4500)
      }
    })
  }

  onEdit () {
    this.$emit('edit')
  }

  onCancel () {
    this.$emit('close')
  }

  handleOpenCloseDomain () {
    this.$emit('open-close-domain', this.form)
  }
}
</script>

<style scoped>
#password-requirements > p {
  position: relative;
}
#password-requirements > p > i {
  margin: 4px;
  float: right;
}
</style>
